const RECENT_KEY = 'studioRecentColors';

export const normalizeHex = (value) => {
  if (!value) return '';
  let hex = value.trim().replace('#', '').toUpperCase();
  if (hex.length === 3) {
    hex = hex.split('').map((c) => c + c).join('');
  }
  if (hex.length !== 6) return '';
  return `#${hex}`;
};

export const hexToRgba = (hex, alpha = 1) => {
  const normalized = normalizeHex(hex);
  if (!normalized) return `rgba(0,0,0,${alpha})`;
  const numeric = parseInt(normalized.slice(1), 16);
  const r = (numeric >> 16) & 255;
  const g = (numeric >> 8) & 255;
  const b = numeric & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getRecentColors = () => {
  if (typeof window === 'undefined') return [];
  try {
    const stored = window.localStorage.getItem(RECENT_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

export const addRecentColor = (hex) => {
  if (typeof window === 'undefined') return [];
  const normalized = normalizeHex(hex);
  if (!normalized) return getRecentColors();
  const current = getRecentColors();
  const next = [normalized, ...current.filter((color) => color !== normalized)].slice(0, 8);
  window.localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  return next;
};
